import { PROJECT_ID_SESSION_KEY } from "..";

export function setSelectedProjectIdToSession(projectId: string) {
  sessionStorage.setItem(PROJECT_ID_SESSION_KEY, projectId);
}
